<template>
    <div class="merchant-logo" :style="logoStyle" tabindex="-1">
        <template v-if="hasLogo">
            <img :src="merchantLogo" alt="" tabindex="-1" />
        </template>
        <template v-else>
            {{ merchantTextLogo }}
        </template>
    </div>
</template>

<script>
  import { contrastColor } from 'contrast-color';
  import { mapGetters, mapState } from 'vuex';

  export default {
      computed: {
          ...mapGetters({
              merchantTextLogo: 'preorder/getMerchantTextLogo',
              merchantLogo: 'merchantLayout/getLogoUrl'
          }),
          ...mapState({
              hasLogo: state => state.merchantLayout.HasLogo,
              backgroundColor: state => state.merchantLayout.BackgroundColor,
          }),
          logoStyle() {
              const bgColor = this.hasLogo ? 'F2F4F8' : this.backgroundColor || '5C6BC0';

              return {
                  backgroundColor: `#${bgColor}`,
                  color: contrastColor({ bgColor: `#${bgColor}` })
              };
          }
      }
  };
</script>

<style lang="scss" scoped>
  .merchant-logo {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 64px;
      height: 64px;
      flex: 0 0 auto;
      border-radius: 50%;
      color: #FFFFFF;
      font-size: 16px;
      font-weight: 700;
      overflow: hidden;
  }

  .merchant-logo img {
      max-width: 100%;
      max-height: 100%;
  }
</style>
